export default __webpack_public_path__ + "static/media/Bond of Anarchy.959a816f.jpg";